define(['app/modules/utilities'], (Util) => {
  function PreferencesSelectors() {
    this.$mainThemeSelect = $('.js-preferences-main-select');
    this.$subThemeSelect = $('.js-preferences-sub-theme-select');
    this.$skillsSelect = $('.js-preferences-skills-select');

    this.showNextSelect = this.showNextSelect.bind(this);
    this.handleUpdateMainTheme = this.handleUpdateMainTheme.bind(this);
    this.handleUpdateSubTheme = this.handleUpdateSubTheme.bind(this);

    this.prepareOptions();
    this.bindEvents();
  }

  PreferencesSelectors.prototype.bindEvents = function () {
    this.$mainThemeSelect.on('change', this.handleUpdateMainTheme);
    this.$subThemeSelect.on('change', this.handleUpdateSubTheme);
  };

  PreferencesSelectors.prototype.prepareOptions = function () {
    const subThemes = this.$subThemeSelect.val();
    const skills = this.$skillsSelect.val();
    this.showNextSelect(
      this.$subThemeSelect,
      ['sub_theme', 'skills'],
      this.getIds([this.$mainThemeSelect, this.$subThemeSelect]),
    );

    this.$subThemeSelect.val(subThemes).trigger('chosen:updated');
    this.$skillsSelect.val(skills).trigger('chosen:updated');
  };

  PreferencesSelectors.prototype.handleUpdateMainTheme = function (event) {
    const $el = $(event.currentTarget);

    this.showNextSelect($el, ['sub_theme', 'skills'], this.getIds([this.$mainThemeSelect]));
  };

  PreferencesSelectors.prototype.handleUpdateSubTheme = function (event) {
    const $el = $(event.currentTarget);

    this.showNextSelect(
      $el,
      ['skills'],
      this.getIds([this.$mainThemeSelect, this.$subThemeSelect]),
    );
  };

  PreferencesSelectors.prototype.showNextSelect = function ($el, selects, selectedIds) {
    selects.forEach((field) => {
      const $nextSelect = $(`#${field}`);

      if (selectedIds.length && $nextSelect.length) {
        return this.updateOptions($nextSelect, selectedIds);
      }

      this.clearOptions($nextSelect, selectedIds);
    });
  };

  PreferencesSelectors.prototype.updateOptions = function ($select, selectedIds) {
    const preferences = $select.data('preferences');
    const skillsFamily = $select.data('skills-family');
    const options = this.filterPreferences(preferences, selectedIds, skillsFamily);
    const selectedValues = $select.val();

    if (options.options.length) {
      const fragment = this.createOptions({ options: options.options, selectedValues });

      $select
        .empty()
        .append(fragment)
        .trigger('chosen:updated');
      $select.parents('.js-form-group').removeClass('hidden');
    } else {
      this.clearOptions($select);
    }
    if (options.skillsGroups.length) {
      Object.keys(options.skillsGroups).forEach((key) => {
        const optgroupEl = document.createElement('optgroup');
        const group = skillsFamily.find(preference => preference.id === +key);
        optgroupEl.label = group.name;
        const fragmentGroup = this.createOptions({ options: options.skillsGroups[key], parent: optgroupEl, selectedValues });
        $select
          .append(fragmentGroup)
          .trigger('chosen:updated');
        $select.parents('.js-form-group').removeClass('hidden');
      });
    }
  };

  PreferencesSelectors.prototype.createOptions = function (params) {
    const fragment = params.parent || document.createDocumentFragment();
    params.options.forEach((option) => {
      const optionEl = document.createElement('option');
      optionEl.value = option.id;
      optionEl.text = option.name;
      optionEl.dataset.id = option.id;

      if (
        params.selectedValues &&
        params.selectedValues.find(value => value === option.id)
      ) {
        optionEl.selected = 'selected';
      }
      fragment.appendChild(optionEl);
    });

    return fragment;
  };

  PreferencesSelectors.prototype.clearOptions = function ($select) {
    $select.empty().trigger('chosen:updated');

    $select.parents('.js-form-group').addClass('hidden');

    const nextSubSelect = $select.data('subThemeId');

    if (nextSubSelect) {
      this.clearOptions($(`#${nextSubSelect}`));
    }
  };

  PreferencesSelectors.prototype.filterPreferences = function (preferences, ids, skillsFamily) {
    ids = ids.map(Number);

    const options = Util.sortAlphabeticallyByKey(preferences.filter(preference => preference.parents.find(i => ids.indexOf(i.id) !== -1)));

    const skillsGroups = [];
    if (skillsFamily) {
      const skillsFamilies = skillsFamily.filter(preference => preference.parents.find(i => ids.indexOf(i.id) !== -1));

      const allSkills = [];
      skillsFamilies.forEach((group) => {
        skillsGroups[group.id] = [];
        preferences.forEach((item) => {
          if (item.parents.find(parent => parent.id === group.id) && !allSkills.includes(item.id)) {
            skillsGroups[group.id].push(item);
            allSkills.push(item.id);
          }
        });
      });
    }
    return { options, skillsGroups };
  };

  PreferencesSelectors.prototype.getIds = function (selects) {
    return selects
      .map(($el) => {
        const $selectedOptions = $el.find('option:selected');

        if ($selectedOptions.length) {
          return [].reduce.call(
            $selectedOptions,
            (acc, curr) => {
              if (curr.dataset.id) acc.push(+curr.dataset.id);

              return acc;
            },
            [],
          );
        }

        return null;
      })
      .reduce((acc, curr) => acc.concat(curr), []);
  };

  return PreferencesSelectors;
});
